import { Media } from "./Media";

export interface Task {
    _id: string;
    name: string;
    pretasks: any[];
    tasks: SubTask[];
    postasks: PosTask[];
    updated: Date;
    userId: string;
    active: boolean;
    authorship: string;
    aims: number[];
    aim_other: string;
    specific_aim: string;
    proficiency_level: number[];
    proficiency_level_comments: string;
    sessions: TaskSession[];
    clonned: boolean;
    original_source: string;
    original_task: string;
    weight: number;
    sectionId?: string;
    task_language: string;
}

export const emptyTask:Task = {
    _id: '',
    name: '',
    pretasks: [],
    tasks: [],
    postasks: [],
    updated: new Date(),
    userId: '',
    active: false,
    authorship: '',
    aims: [],
    aim_other: '',
    specific_aim: '',
    proficiency_level: [],
    proficiency_level_comments: '',
    sessions: [],
    clonned: false,
    original_source: '',
    original_task: '',
    weight: 0,
    sectionId: undefined,
    task_language: 'en',
}

export interface PreTask {
    _id: string;
    name: string;
    updated: Date;
    type: string;
    instructions: string;
    text: string;
    formatted_text: string;
    media: Media[];
    session: string;
    students: boolean;
    teachers: boolean;
    teacher_notes: string;
}

export interface PreTaskText {
    id: number;
    name: string;
    introduction: string;
    text: string;
    updated: Date;
}

export interface PreTaskAudio {
    id: number;
    name: string;
    introduction: string;
    text: string;
    media: Media[];
    updated: Date;
}

export interface SubTask {
    _id: string;
    name: string;
    updated: Date;
    groups: SubTaskGroup[];
    roles: SubTaskRole[];
    prompts: SubTaskPrompt[];
    goal: string;
    students: number;
    grouping: string;
    studentsPerGroup: number;
    session: string;
    students_session: boolean;
    teachers_session: boolean;
    teacher_notes: string;
}

export interface PosTask {
    _id: string;
    name: string;
    updated: Date;
    type: String;
    instructions: string;
    text: string;
    formatted_text: string;
    media: Media[];
    session: string;
    students: boolean;
    teachers: boolean;
    teacher_notes: string;
}

export interface SubTaskStudent {
    _id: string,
    name: string,
    role: number,
    prompt: number
}
export interface SubTaskGroup {
    _id: string;
    name: string;
    color: string;
    students: SubTaskStudent[];
}

export interface SubTaskRole {
    _id: string;
    name: string;
    color: string;
    groups: number[];
}

export interface SubTaskPrompt {
    _id: string;
    name: string;
    instructions: string;
    media: Media[];
    text: string;
    formatted_text: string;
    roles: number[];
    teacher_notes: string;
}

export interface TaskSession {
    _id: string,
    name: string,
    datetime: Date
}

export interface TaskExample {
    _id: string;
    task: {
        _id: string;
        name: string;
        updated: Date;
    },
    weight: number
}

export const emptyTaskExample = {
    _id: '',
    task: {
        _id: '',
        name: '',
        updated: new Date()
    },
    weight: 0
}

export interface TaskTag {
    _id: string;
    name: string;
    userId: string;
}

export interface TaskTagTask {
    _id: string;
    tagId: string;
    taskId: string;
}

export const aimsOfTask = [
    {
        value: 1,
        description: "To describe an object, person or place"
    },
    {
        value: 2,
        description: "To solve a communication problem or gap"
    },
    {
        value: 3,
        description: "To create a design or plan"
    },
    {
        value: 4,
        description: "To to make a decision or choice"
    },
    {
        value: 5,
        description: "To explain a process"
    },
    {
        value: 6,
        description: "To tell a story"
    },
    {
        value: 7,
        description: "To reach an agreement"
    },
    {
        value: 8,
        description: "To learn new content (focus on meaning)"
    },
    {
        value: 9,
        description: "To fill out a form"
    },
    {
        value: 10,
        description: "To make a complaint"
    },
    {
        value: 11,
        description: "To request information"
    },
    {
        value: 12,
        description: "To formulate an argument"
    },
    {
        value: 13,
        description: "To express an opinion"
    },
    {
        value: 14,
        description: "To foster critical language awareness"
    }
];

export const proficiencyLevelsOfTask = [
    {
        value: 1,
        description: "A1 Movers"
    },
    {
        value: 2,
        description: "A2 Key"
    },
    {
        value: 3,
        description: "B1 Preliminary"
    },
    {
        value: 4,
        description: "B2 First"
    },
    {
        value: 5,
        description: "C1 Advanced"
    },
    {
        value: 6,
        description: "C2 Proficiency"
    }
];

export interface TaskSection {
    _id: string;
    name: string;
    userId: string;
    parentId: string | null;
    weight: number;
    expanded: boolean;
    children?: TaskSection[];
}

export const emptyTaskSection: TaskSection = {
    _id: '',
    name: '',
    userId: '',
    parentId: null,
    weight: 0,
    expanded: true,
    children: [],
};

// Task sharing permission types
export type SharePermission = 'view' | 'edit';

export interface TaskShareUser {
    id: string;
    label: string;
    permission: SharePermission;
}

export interface SharedTaskInfo {
    _id: string;
    name: string;
    updated: Date;
    userId?: string;
    userFullName?: string;
    group?: string;
    permission?: SharePermission;
    canEdit?: boolean;
}
